module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURSw+UEdwTCw+UCw8UCw9UCBAUCw+UCs9UCs9UCk9UCwb3d8AAAAKdFJOU/8AgEDAEH9g5VDHNpteAAAAgklEQVQoz2MQRAMM5AkYGxubCgoGAymIQAQDEASKgshGsMCEFheXhkJxDhcXD2awgIGjoKCCohCToKAIFQXa0tIcCsVZ0tIyIAIBCHewggVEi5SUSgUFw5WU1AOJ9JxoWVoaSEtaWnogdkMNmpSUQNYqKWnQ0nPoQYgRyBjRQHHcAgA5BDZFGs8VHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/dark-nav-icon.png
// module id = 207
// module chunks = 0